import { useState, useEffect } from "react"
import { getCookie, deleteCookie } from "../utils/cookies"
import { Link, useNavigate } from "react-router-dom"
import { Button } from "../components/ui/button.tsx"
import { Phone, Calendar, User } from "lucide-react"
import { HeaderNav } from "./header-nav"
import { LoginModal } from "./auth/LoginModal"
import { NewsTicker } from "./NewsTicker"

export function Header() {
  const navigate = useNavigate()

  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const [user, setUser] = useState(null)

  // Dynamic Images State
  const [headerImages, setHeaderImages] = useState({
    pranaamLogo: "",
    sinceLogo: "",
    nabhLogo: "",
  })

  // User Data
  useEffect(() => {
    const savedUser = getCookie("user")

    if (savedUser && savedUser !== "undefined") {
      try {
        setUser(JSON.parse(savedUser))
      } catch (e) {
        console.error(e)
      }
    }

    const handleUserUpdated = (e) => setUser(e.detail)

    window.addEventListener("user-updated", handleUserUpdated)

    return () => {
      window.removeEventListener("user-updated", handleUserUpdated)
    }
  }, [])

  // Fetch Header Images From WordPress
  useEffect(() => {
    fetch("/wp-json/custom/v1/header-images")
      .then((res) => res.json())
      .then((data) => {
        console.log("API DATA:", data)

        setHeaderImages({
          pranaamLogo: data.pranaam_logo,
          sinceLogo: data.since_24_years_logo,
          nabhLogo: data.nabh_logo,
        })
      })
      .catch((err) => console.error(err))
  }, [])

  const handleLogout = () => {
    deleteCookie("user")
    deleteCookie("accessToken")
    deleteCookie("refreshToken")

    setUser(null)

    navigate("/")
  }

  return (
    <>
      <header className="sticky top-0 z-50 w-full bg-white border-b shadow-sm py-1">
        
        {/* Header Container */}
        <div className="container flex items-center justify-between h-22 px-4 mx-auto">

          {/* Dynamic Pranaam Logo */}
          <div className="flex items-center gap-2 shrink-0">
            <Link to="/">
              <img
                src={
                  headerImages.pranaamLogo ||
                  "https://pranaamhospitals.com//wp-content/uploads/2026/05/pranaam-logo.png"
                }
                alt="Pranaam Hospitals Logo"
                width={160}
                height={80}
                className="h-20 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden xl:block">
            <HeaderNav />
          </div>

          {/* Right Side */}
          <div className="flex items-center gap-2">

            {/* Phone */}
            <div className="hidden xl:flex items-center gap-2">
              <a href="tel:+919966060000" className="flex items-center">
                <Phone className="w-4 h-4 text-primary animate-pulse" />
              </a>
            </div>

            {/* Book Now */}
            <Button size="sm" className="hidden xl:inline-flex" asChild>
              <a href="/book-now">
                <Calendar className="w-4 h-4 mr-1" />
                Book Now
              </a>
            </Button>

            {/* Login / User */}
            {user ? (
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate("/portal-dashboard")}
              >
                <User className="w-5 h-5" />
              </Button>
            ) : (
              <Button
                size="sm"
                variant="outline"
                onClick={() => setIsLoginOpen(true)}
              >
                Login
              </Button>
            )}

            {/* Mobile Menu */}
            <div className="xl:hidden">
              <HeaderNav />
            </div>

            {/* Since 24 Years Logo */}
            {headerImages.sinceLogo && (
              <img
                src={headerImages.sinceLogo}
                alt="Since 24 Years"
                className="hidden xl:block h-10 w-10 object-contain"
              />
            )}

            {/* NABH Logo */}
            {headerImages.nabhLogo && (
              <img
                src={headerImages.nabhLogo}
                alt="NABH"
                className="hidden xl:block h-10 w-10 object-contain"
              />
            )}
          </div>
        </div>

        {/* Login Modal */}
        <LoginModal
          isOpen={isLoginOpen}
          onClose={() => setIsLoginOpen(false)}
          onLoginSuccess={setUser}
        />
      </header>

      {/* News Ticker */}
      <NewsTicker />
    </>
  )
}